import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AdminDashboardDataService } from 'src/app/admindashboard/services/admindashboard-data.service';
import { Company } from "src/app/processing/models/company";


 @Component({
    selector: 'app-company-terms-view',
    templateUrl: './company-terms-view.component.html',
    standalone: true,
    imports: [CommonModule, CompanyTermsViewComponent],
 })

 export class CompanyTermsViewComponent implements OnInit {
    termsContent: string = '';
    companyCode: string  = '';
    companyName: string = '';

    constructor(
      private route: ActivatedRoute,
      private adminDashboardDataService: AdminDashboardDataService
    ) {}

   //  ngOnInit(): void {
   //      this.companyCode = this.route.snapshot.paramMap.get('companyCode') || '';
   //      this.termsContent = localStorage.getItem(`termsContent_${this.companyCode}`) || '<p>No Terms and Conctions have been set yet.</p>'

   //      // Fetching company name above it's t & c
   //      this.adminDashboardDataService.getCompanies().subscribe((companies: Company[]) => {
   //       const company = companies.find(c => c.Code === this.companyCode);
   //       this.companyName = company ? company.Name : '';
   //      })
   ngOnInit(): void {
  this.companyCode = this.route.snapshot.paramMap.get('companyCode') || '';

  this.adminDashboardDataService.getTerms(this.companyCode).subscribe({
    next: (html) => {
      this.termsContent = html;
    },
    error: () => {
      this.termsContent = '<p>No Terms and Conditions have been set yet.</p>';
    }
  });

  this.adminDashboardDataService.getCompanies().subscribe((companies: Company[]) => {
    const company = companies.find(c => c.Code === this.companyCode);
    this.companyName = company ? company.Name : '';
  });
}
 }